<form [formGroup]="generalForm">
  <div class="row">
    <div class="col-6">
      <div class="form-section">
        <div class="mb-3">
          <label for="campaign_stock_reference" class="form-label">{{
            "inputs.campaign_stock_reference" | translate
            }}</label>
          <div class="input-group div-copy">
            <input type="text" class="form-control" id="campaign_stock_reference" #inputStockCampaignStockReference formControlName="campaign_stock_reference"
              placeholder="{{
                  'inputs.campaign_stock_reference' | translate
                }}" required />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary copy"  type="button"
                (click)="copyToClipboard(inputStockCampaignStockReference.value,$event)">
                <i class="icon-copy"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
     <div class="col-3">
        <div class="form-section">
          <div class="mb-3">
            <label for="units" class="form-label">{{
              "inputs.total_units" | translate
              }}</label>
            <div class="input-group div-copy">
              <input type="text" class="form-control" id="units" formControlName="units" placeholder="{{
                  'inputs.total_units' | translate
                }}" required />
            </div>

          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="form-section">
          <div class="mb-3">
            <label for="hidden_units" class="form-label">{{
              "inputs.hidden_units" | translate
              }}</label>
            <div class="input-group div-copy">
              <input type="text" class="form-control" id="hidden_units" formControlName="hidden_units" placeholder="{{
                  'inputs.hidden_units' | translate
                }}" />
            </div>
          </div>
        </div>
      </div>
  </div>
  <!-- Vendor,sup,bro,dealer -->
  <div class="form-section">
    <div class="row">
     
    </div>
  </div>

  <div class="row" *ngIf="stockData?.stage">
    <div class="col-6">
      <div class="mb-3">
        <ng-select formControlName="stage" [items]="stagesList" bindValue="key"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          (change)="changeStage($event?.key)">
          <ng-template ng-label-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="mb-3">
      <label for="comments" class="form-label">{{
        "inputs.comments" | translate
        }}</label>
      <textarea class="form-control textarea150" id="comments" rows="5" formControlName="comments"></textarea>
    </div>
  </div>

  <div class="row">
    <div class="mb-3">
      <label for="delivery_comments" class="form-label">{{
        "inputs.delivery_comments" | translate
        }}</label>
      <textarea class="form-control textarea150" id="delivery_comments" rows="5"
        formControlName="delivery_comments"></textarea>
    </div>
  </div>

  <!--  <div *ngIf="draft">
    <div class="form-section">
      <label for="stage" class="form-label">{{ "inputs.stage" | translate }}
        <span class="required">*</span></label>
      <div class="row">
        <div class="col-6">
          <div class="mb-3">

            <select id="stage" class="form-control" formControlName="stage" (ngModelChange)="changeStage($event)">
              <option [value]="orderData.stage" selected>
                {{
                "badge-status_select-stage." + orderData.stage
                | translate
                }}
              </option>
              <option *ngFor="let type of orderData.stages" [value]="type" [selected]="type === orderData.stage">
                {{
                "badge-status_select-stage." + type | translate
                }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="btn-next" *ngIf="btn_fast_actions">
            <button *ngIf="next_ok" type="submit" class="btn btn-primary btn-next_ok"
              (click)="onSubmitOrderFast(next_ok)"> <i class="icon-next-circle"></i>
              {{ "badge-status_select-stage."+ next_ok | translate }}
            </button>

            <button *ngIf="next_ko" type="submit" class="btn btn-primary btn-next_ko"
              (click)="onSubmitOrderFast(next_ko)"> <i class="icon-pause-circle"></i>
              {{ "badge-status_select-stage."+ next_ko | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="row private-background" *ngIf="role == 'Logistics'|| role == 'Workshop'">
        <div class="mb-3">
          <label for="notes" class="form-label">{{
            "inputs.addinternote" | translate
            }}</label>
          <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
        </div>
      </div>
      <div class="row" *ngIf="role != 'Logistics' &&  role != 'Workshop'">
        <div class="mb-3">
          <label for="notes" class="form-label">{{
            "inputs.addnote" | translate
            }}</label>
          <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
        </div>
      </div>
    </div>
  </div> -->
</form>
